import { render } from "./subpartA08.vue?vue&type=template&id=5cafa55a&scoped=true"
import script from "./subpartA08.vue?vue&type=script&lang=js"
export * from "./subpartA08.vue?vue&type=script&lang=js"

import "./subpartA08.vue?vue&type=style&index=0&id=5cafa55a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cafa55a"]])

export default __exports__